import { tokens } from './tokens.js';

/**
 * The light theme's name. This is also the value the app stores in
 * `store.state.theme` and the value Vuetify's `theme.global.name` holds.
 * @type {'light'}
 */
export const THEME_LIGHT = 'light';

/**
 * The dark theme's name — the counterpart of {@link THEME_LIGHT}.
 * @type {'dark'}
 */
export const THEME_DARK = 'dark';

/**
 * Vuetify theme definitions, keyed by theme name. Handed to
 * `createVuetify({ theme: { themes } })` — see `createDashboardVuetify`.
 *
 * @type {Record<'light'|'dark', { dark: boolean, colors: Record<string, string> }>}
 */
export const vuetifyThemes = {
  [THEME_LIGHT]: { dark: false, colors: tokens.palette.light },
  [THEME_DARK]: { dark: true, colors: tokens.palette.dark },
};
